import FeatherIcon from "feather-icons-react"
import { useSelector } from "react-redux";
import { formatMoneyWithCurrency } from "src/utils/formatter"
import "./bulkActionsBar.css"


export const BulkActionsBar = ({
    totalAmountSelected = 0,
    totalSelected,
    settleSelected,
    costCenters,
    setSelectedDocs,
    showInSidebar = false,
    settleActionsDropdown,
    editActionsDropdown,
    setTotalSelected,
    deleteTransacitions,
    multipleObligation,
    multipleMatch,
    setCheckedTransactions,
    createNominaDropdown, // Nueva prop para el dropdown de nómina
    hideSettleSelected = false,
    acuseDeRecibo,
    asientoMasivo,
    abonar,
    desconciliar,
    interAccountTransfer,
}) => {
    const { openSidebar } = useSelector((state) => state.openSidebar);

    const clear = () => {
        if (setSelectedDocs) setSelectedDocs([]);
        if (setTotalSelected) setTotalSelected(0);
        if (setCheckedTransactions) setCheckedTransactions([]);
    }

    const hasActionButtons = (
        (settleSelected && !hideSettleSelected) ||
        costCenters ||
        settleActionsDropdown ||
        editActionsDropdown ||
        deleteTransacitions ||
        multipleObligation ||
        multipleMatch ||
        createNominaDropdown ||
        acuseDeRecibo ||
        asientoMasivo ||
        abonar ||
        desconciliar ||
        interAccountTransfer
    )

    return (
        <section
            className={`bulk-actions-bar tw-fixed tw-bottom-20 tw-left-1/2 -tw-translate-x-1/2 tw-min-w-[280px] tw-max-w-[95vw] sm:tw-max-w-[90vw] md:tw-max-w-[80vw] lg:tw-max-w-[70vw] tw-h-auto tw-min-h-[42px] tw-p-2 tw-pl-3 tw-pr-2 tw-rounded-lg tw-gap-2 tw-bg-gray-800 tw-text-gray-200 tw-flex tw-items-center tw-justify-between tw-text-xs sm:tw-text-sm tw-shadow-lg tw-z-[9999] tw-flex-wrap`}
        >
            <span className="tw-font-normal tw-whitespace-nowrap tw-text-xs sm:tw-text-sm">
                Total: {formatMoneyWithCurrency(totalAmountSelected)}
            </span>
            <span className="tw-font-normal tw-whitespace-nowrap tw-text-xs sm:tw-text-sm">
                Seleccionados: {totalSelected || 0}
            </span>

            {
                hasActionButtons &&
                <div className="tw-h-full tw-w-[1.2px] tw-bg-gray-300"></div>
            }

            {
                settleSelected && !hideSettleSelected &&
                <button
                    className="tw-bg-transparent tw-border-none tw-text-white tw-p-1 tw-rounded tw-whitespace-nowrap"
                    onClick={() => settleSelected(true)}
                >
                    <span className="tw-font-medium tw-text-xs sm:tw-text-sm" >
                        Saldar seleccionado
                    </span>
                </button>
            }
            {
                settleActionsDropdown &&
                settleActionsDropdown
            }
            {
                editActionsDropdown &&
                editActionsDropdown
            }
            {
                createNominaDropdown &&
                createNominaDropdown
            }
            {
                deleteTransacitions &&
                deleteTransacitions
            }
            {
                multipleObligation &&
                multipleObligation
            }
            {
                multipleMatch &&
                multipleMatch
            }
            {
                interAccountTransfer &&
                interAccountTransfer
            }
            {
                acuseDeRecibo &&
                acuseDeRecibo
            }
            {
                asientoMasivo &&
                asientoMasivo
            }
            {
                abonar &&
                abonar
            }
            {
                desconciliar &&
                desconciliar
            }
            {
                hasActionButtons &&
                <div className="tw-h-full tw-w-[1.2px] tw-bg-gray-300"></div>
            }
            <button
                className="tw-bg-transparent tw-border-none tw-w-[32px] tw-h-[32px] tw-flex tw-items-center tw-justify-center tw-rounded tw-hover:tw-bg-gray-700 tw-transition-colors tw-flex-shrink-0"
                onClick={(event) => {
                    event.preventDefault();
                    clear();
                }}
            >
                <FeatherIcon
                    icon="x"
                    size={12}
                    strokeWidth={3}
                    className="tw-text-white"
                />
            </button>
        </section>
    )
}
